// /src/store/reducers/loaderSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isGlobalLoader: true,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader(state) {
      state.isGlobalLoader = true;
    },
    hideLoader(state) {
      state.isGlobalLoader = false;
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
